<template>
    <label
        class="switch"
        :for="`toggle-${id}`"
        :class="{ 'switch--disabled': disabled }"
        style="user-select: none;"
    >
        <input
            type="checkbox"
            :id="`toggle-${id}`"
            :checked="checked"
            :disabled="disabled"
            @input="emitToggle"
        />
        <span 
            class="slider round" 
            :style="{
                backgroundColor: checked ? (color || '#32A555') : '#ccc'
            }"
        ></span>
    </label>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    id: {
        type: Number,
        default: -1,
    },
    checked: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    color: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['callBack']);

function emitToggle(event) {
    emit('callBack', event.target.checked);
}
</script>
<style>
    .switch {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 22px;
    }

    .switch--disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .switch--disabled .slider {
        cursor: not-allowed;
        background-color: #e5e5e5;
    }

    .switch--disabled .slider:before {
        background-color: #f5f5f5;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 18px;
        width: 18px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px rgba(0, 0, 0, 0.2);
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(18px);
        -ms-transform: translateX(18px);
        transform: translateX(18px);
    }
    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
</style>
